<template lang="pug">
.service-times
  .service-time(v-for="time in times")
    b {{ time.weekday }}
    b-table(
      :data="time.services"
      :mobile-cards="false"
    )
      template(slot-scope="props")
        b-table-column(label="Service") {{ props.row.title }}
        b-table-column(label="Start") {{ props.row.start_time | date('h:mm A') }}
</template>

<script>
import { HTTP } from '@/utils/http';

export default {
  name: 'service-times',
  created() {
    HTTP.get('/_views/times')
      .then(({ data }) => {
        this.times = data.data.times;
      });
  },
  data() {
    return {
      times: [],
    };
  },
};
</script>

<style lang="scss">
.service-times {
  max-width: 90%;
  .service-time + .service-time {
    margin-top: 1.75rem;
  }
  b {
    display: block;
    padding-bottom: 0.5rem;
    font-weight: 600;
    font-size: 0.9rem;
  }
  .table {
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
    background-color: transparent;
    color: #999999;
    thead {
      display: none;
    }
    tbody {
      tr {
        td:first-child {
          padding-left: 0;
        }
        td:last-child {
          text-align: right;
          padding-right: 0;
        }
      }
    }
  }
}
</style>
